import {Route,Switch,BrowserRouter } from "react-router-dom";

import DriversTable from "components/Doobi/Drivers";
import DoobiHeader from "components/Headers/DoobiHeader";

const DriversRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Drivers" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/`} component={DriversTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default DriversRoute;
